import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl } from '@angular/forms';
import { LanguagesService } from '../../../services/language.service';
import { BaseService } from '../../../services/base.service';
import { ValidationService } from 'src/app/services/validation.service';
import { Education } from '../../../../assets/class/Education';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-educition',
  templateUrl: './educition.component.html',

})
export class EducitionComponent implements OnInit {
  @Input() form: FormGroup = null;
  myEducition: FormArray;
  educationList;
  educ: Education;
  public required = new Array<any>();
  constructor(public languagesService: LanguagesService,
    public baseService: BaseService,
    private translate: TranslateService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.form.addControl('myEducition', this.formBuilder.array([this.createMyEducitionItem()]));
    this.myEducition = this.form.get('myEducition') as FormArray;

  }
  addMyEducitionItem() {
    this.myEducition.push(this.createMyEducitionItem());

  }

  createMyEducitionItem() {
    return this.formBuilder.group({
      studyField: new FormControl('', []),
      DegreeCertificate: new FormControl('', [])
    });
  }
  removeMyEducition(i) {
    this.myEducition.removeAt(i);
    this.required[i] = false;
  }

  public get f() {
    return this.form.controls;
  }

  public get f2() {
    return this.myEducition.controls as Array<FormGroup>;
  }

  public change(i) {
    this.required[i] = true;
    ValidationService.SetValidators(this.f2[i].controls.DegreeCertificate);
  }

  onSubmit() {
    this.educationList = new Array<any>()

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return false;
    }

    let i = 0, j = 0;
    //אם יש יותר משורה אחת בדיקה שאין שורות חופפות!
    for (i = 0; i < this.myEducition.length; i++) {
      let error;
      for (j = i; j < this.myEducition.length; j++) {
        if (i != j) {

          error = ValidationService.compareEducation(this.f2[i].controls, this.f2[j].controls)
          if (error) {
            this.f2[j].controls.DegreeCertificate.setErrors(error);
            return;
          }
        }
      }

      if (this.form.controls.myEducition.value[i].studyField != "" && (i == j)) {

        let educat = {
          Uid: this.baseService.LoggedUser.MEZAHE_ZAFUY_INTERNET,
          KodStudyField: this.form.controls.myEducition.value[i].studyField,
          TeurStudyField: this.baseService.taasuka.find(f => f.THUM_MIKZOA == [Number(this.form.controls.myEducition.value[i].studyField)]).TEUR_THUM,
          KodDegree: this.form.controls.myEducition.value[i].DegreeCertificate,
          TeurDegree: this.baseService.megama.find(f => f.KOD == [Number(this.form.controls.myEducition.value[i].DegreeCertificate)]).TEUR
        }
        this.educationList.push(educat);
      }


    }

  }

}
